import { render, staticRenderFns } from "./Side.vue?vue&type=template&id=28e8f204&scoped=true"
import script from "./Side.vue?vue&type=script&lang=js"
export * from "./Side.vue?vue&type=script&lang=js"
import style0 from "./Side.vue?vue&type=style&index=0&id=28e8f204&prod&scoped=true&lang=css"
import style1 from "./Side.vue?vue&type=style&index=1&id=28e8f204&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e8f204",
  null
  
)

export default component.exports